<template>
  <div class="claim-register">
    <div class="claim-register-container">
      <div class="head">
        <el-radio-group
          class="select-tab"
          v-model="selectedTab"
          @change="toUrl"
        >
          <el-radio-button label="索赔登记"></el-radio-button>
          <el-radio-button label="待确认表单"></el-radio-button>
          <el-radio-button label="已确认表单"></el-radio-button>
        </el-radio-group>
      </div>
      <div class="content">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          hide-required-asterisk
        >
          <div class="top">
            <div class="orther-search">
              <div class="orther-search-title">其他信息项：</div>
              <div class="orther-search-main">
                <div class="orther-search-row">
                  <el-form-item label="仓库：" prop="name">
                    <el-select
                      class="gray white"
                      v-model="ruleForm.warehouseId"
                      placeholder="请选择仓库"
                    >
                      <el-option
                        v-for="item in warehouse"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="时间：" prop="billDate">
                    <el-date-picker
                      class="w190"
                      v-model="ruleForm.billDate"
                      type="date"
                      placeholder="请选择日期"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="快递公司：" prop="expressId">
                    <el-select
                      class="gray white"
                      v-model="ruleForm.expressId"
                      placeholder="请选择仓库"
                    >
                      <el-option
                        v-for="item in expressCompanyList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="orther-search-row">
                  <el-form-item
                    label="客户名称："
                    prop="customerId"
                  >
                    <el-select
                      class="gray white"
                      v-model="ruleForm.customerId"
                      placeholder="请选择客户"
                      filterable
                      @change="changeCustomer"
                    >
                      <el-option
                        v-for="item in customerList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    label="项目名称："
                    prop="projectId"
                  >
                    <el-select
                      class="gray white"
                      v-model="ruleForm.projectId"
                      placeholder="请选择项目"
                    >
                      <el-option
                        v-for="item in projectNameList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
          <div class="main">
            <div class="main-title">索赔内容</div>
            <div class="main-row">
              <div class="w50 quantity">
                <el-form-item class="w50 quantity" label="订单号：" prop="orderCode">
                  <el-input
                    class="gray white"
                    v-model="ruleForm.orderCode"
                    placeholder="请填写信息"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item class="w50" label="快递单号：" prop="expressCode">
                  <el-input
                    class="gray white"
                    v-model="ruleForm.expressCode"
                    placeholder="请填写信息"
                    clearable
                  ></el-input>
                </el-form-item>
              </div>
              <el-form-item class="w50" label="具体问题：" prop="questionContent">
                <el-input
                  class="gray white"
                  v-model="ruleForm.questionContent"
                  placeholder="请填写信息"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <div class="main-row">
              <el-form-item label="认责方：" prop="responsibleParty">
                <el-select
                  class="gray white"
                  v-model="ruleForm.responsibleParty"
                  placeholder="请选择认责方"
                  @change="changeResponsibleParty"
                >
                  <el-option
                    v-for="item in responsiblePartyList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="问题分类：" prop="logisticsProblemsType">
                <el-select
                  class="gray white"
                  v-model="ruleForm.logisticsProblemsType"
                  placeholder="请选择问题分类"
                >
                  <el-option
                    v-for="item in logisticsProblemTypeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="产品名称：" prop="productName">
                <el-input
                  class="gray white"
                  v-model="ruleForm.productName"
                  placeholder="请填写信息"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="数量：" prop="quantity">
                <el-input
                  class="gray white"
                  v-model="ruleForm.quantity"
                  placeholder="请填写信息"
                  clearable
                  @input="inputNums(ruleForm.quantity)"
                ></el-input>
              </el-form-item>
            </div>
            <div class="main-row">
              <div class="w50 quantity">
                <el-form-item class="w50 quantity" label="处理方案：" prop="dealMethod">
                  <el-select
                    class="gray white"
                    v-model="ruleForm.dealMethod"
                    placeholder="请选择处理方案"
                  >
                    <el-option
                      v-for="item in dealMethodList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="w50" label="涉及金额：" prop="involvedAmount">
                  <el-input
                    class="gray white"
                    v-model="ruleForm.involvedAmount"
                    placeholder="请填写信息"
                    @input="inputAmount(ruleForm.involvedAmount, 'involvedAmount')"
                    clearable
                  ></el-input>
                </el-form-item>
              </div>
              <el-form-item class="w50 remarks" label="备注：" prop="remarks">
                <el-input
                  class="gray white"
                  v-model="ruleForm.remarks"
                  placeholder="请填写信息"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <div class="main-row">
              <el-form-item label="上传照片：" prop="images" class="images">
                <el-upload
                  ref="upload"
                  action="#"
                  :class="ruleForm.images.length < 3 ?'':'none'"
                  list-type="picture-card"
                  :limit="3"
                  :on-exceed="handleLimit"
                  :on-remove="onRemove"
                  :before-upload="beforeUpload"
                  :auto-upload="true"
                  :file-list="fileList"
                >
                  <el-button
                    v-loading="loading"
                    element-loading-text="上传中..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    slot="trigger"
                    size="small"
                    type="primary"
                  >
                    <i class="el-icon-plus add"></i>
                  </el-button>
                  <div
                    slot="tip"
                    class="el-upload__tip"
                  >最多上传3张，支持jpg、jpeg、png格式</div>
                </el-upload>
              </el-form-item>
            </div>
            <el-form-item class="foot">
              <el-button
                type="primary"
                class="btn-blue"
                @click="submitForm('ruleForm')"
                >保存</el-button
              >
              <el-button @click="cancel('ruleForm')">清空</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Claim from "models/claim";
import ChargeRegister from "models/charge-register";
import Expenses from "models/expenses";
const expenses = new Expenses();
import Logistics from "models/logistics";
const logistics = new Logistics();
import ImgUploader from "common/js/img-upload.js";
const imgUploader = new ImgUploader();
import { formatTimeToDate } from "common/js/util";
export default {
  data() {
    return {
      selectedTab: "索赔登记",
      warehouse: [],
      expressCompanyList: [],
      customerList: [],
      projectNameList: [],
      logisticsProblemTypeList: [],
      dealMethodList: [
        {id:1, name: '补发'},
        {id:2, name: '退差价'},
        {id:3, name: '退款'},
      ],
      responsiblePartyList: [
        {id:1, name: '仓库'},
        {id:2, name: '物流'}
      ],
      fileList: [],
      loading: false,
      ruleForm: {
        warehouseId: '',
        billDate: formatTimeToDate(new Date()),
        expressId: '',
        customerId: '',
        projectId: '',
        orderCode: '',
        expressCode: '',
        questionContent: '',              // 具体问题
        logisticsProblemsType: '',        // 物流问题分类
        productName: '',
        quantity: 0,
        dealMethod: '',                   // 处理方案
        involvedAmount: '',               // 涉及金额
        remarks: '',
        images: [],
        responsibleParty: '',
      },
      rules: {
        expressCode: [
          {
            required: true,
            message: "请输入快递单号",
            trigger: "blur",
          },
        ],
        responsibleParty: [
          {
            required: true,
            message: "请选择认责方",
            trigger: "change",
          },
        ],
        logisticsProblemsType: [
          {
            required: true,
            message: "请选择物流问题分类",
            trigger: "change",
          },
        ],
        dealMethod: [
          {
            required: true,
            message: "请选择物流处理方案",
            trigger: "change",
          },
        ],
        involvedAmount: [
          {
            required: true,
            message: "请输入涉及金额",
            trigger: "blur",
          },
        ],
      }
    };
  },

  created() {
    this.initGetWarehouse()
    this.getLogisticsList()
    this.initGetCustomerList()
  },
  methods: {
    toUrl(v) {
      if (v === "待确认表单") {
        this.$router.push({
          path: "/service/claim-index/tbc-record",
        });
      } else if(v === "已确认表单") {
        this.$router.push({
          path: "/service/claim-index/confirmed-record",
        });
      } else {
        this.$router.push({
          path: "/service/claim-index/claim-register",
        });
      }
    },
    /* 获取仓库数据 */
    initGetWarehouse() {
      expenses.getWarehouseData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouse = arr;
          this.ruleForm.warehouseId = this.warehouse[0].id;
        }
      });
    },
    //获取快递公司列表
    getLogisticsList() {
      logistics.getExpressData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.expressCompanyList = arr;
          this.ruleForm.expressId = this.expressCompanyList[0].id;
        }
      });
    },
    /* 获取客户名称 */
    initGetCustomerList() {
      logistics.getCustomerData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.ordersName;
            arr.push(obj);
          });
          this.customerList = arr;
          this.ruleForm.customerId = arr[0].id;
          this.initGetProjectList()
        }
      });
    },
    changeCustomer() {
      this.initGetProjectList()
    },
    /* 获取项目名称 */
    initGetProjectList() {
      let customerId = this.ruleForm.customerId
      let warehouseId = this.ruleForm.warehouseId
      ChargeRegister.getProjectList(customerId, warehouseId).then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.projectsName;
            arr.push(obj);
          });
          this.projectNameList = arr;
          this.ruleForm.projectId = arr[0].id;
        }
      });
    },
    /* 获取问题分类 */
    initProblemTypeList() {
      let responsibleType = this.ruleForm.responsibleParty
      Claim.postProblemTypeList(responsibleType).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.name = i.text
            arr.push(obj)
          })
          this.logisticsProblemTypeList = arr;
        } else {
          this.$message.error(res.message)
        }
      })
    },
    changeResponsibleParty() {
      this.initProblemTypeList()
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {}
          data = this.ruleForm
          Claim.postAddClaimRegister(data).then(res => {
            if (res.success) {
              this.$message.success('保存成功')
              this.$router.push({
                path: "/service/claim-index/tbc-record",
              });
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      })
    },
    cancel(formName) {
      this.fileList = []
      this.$refs[formName].resetFields();
      this.ruleForm.expressId = this.expressCompanyList[0].id;
      this.initGetCustomerList()
    },
    /* 限制金额为2位小数 */
    inputAmount(val, type) {
      let price = val.toString().match(/^\d*(\.?\d{0,2})/g)
        ? val === "00"
          ? "0"
          : val.toString().match(/^\d*(\.?\d{0,2})/g)[0]
        : "";
      this.ruleForm[type] = price;
    },
    /* 限制数量为正整数 */
    inputNums(val) {
      let quantity = val.toString().match(/^(\+)?\d*/g)
        ? val === "00"
          ? "0"
          : val.toString().match(/^(\+)?\d*/g)[0]
        : "";
      this.ruleForm.quantity = Number(quantity);
    },
    /* ------------------------------ 以下是上传图片方法 --------------------------- */
    // 图片数量大于3
    handleLimit() {
      this.$message({
        message: "图片数量最多3张",
        type: "warning",
      });
    },
    // 删除图片
    onRemove(file, fileList) {
      this.fileList = fileList;
      this.ruleForm.images = [];
      this.fileList.map(value => {
        this.ruleForm.images.push(value.url);
      });
    },
    // 上传图片进行判断图片
    beforeUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/bmp" ||
        file.type === "image/jpg";
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isJPG) {
        this.$message.error("上传图片格式错误!");
        return false;
      } else if (!isLt1M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
        return false;
      } else {
        this.loading = true;
        this.file = file;
        imgUploader
          .postImgUpload(this.file)
          .then((res) => {
            if (res.errorCode === 0) {
              let obj = {};
              obj.url = res.imgUrl;
              this.fileList.push(obj);
              this.loading = false;
              this.ruleForm.images = [];
              this.fileList.map(value => {
                this.ruleForm.images.push(value.url);
              });
            } else {
              this.loading = false;
              this.$message.error("图片上传超时，请重新上传");
            }
          })
          .catch(() => {
            this.loading = false;
            this.$message.error("图片上传超时，请重新上传");
          });
        return false;
        // console.log(file);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.claim-register {
  flex: 1;
  .claim-register-container {
    flex: 1;
    border-radius: 4px;
    .head {
      margin-bottom: 16px;
      font-size: 14px;
      font-weight: 400;
      background: #f2f4f8;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .content {
      .top {
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        padding: 32px 37px 25px 37px;
        background: #fff;
        margin-bottom: 20px;
        border-radius: 8px;
        background: #fff;
        .orther-search {
          display: flex;
          justify-content: flex-start;
          .orther-search-title {
            font-size: 14px;
            line-height: 32px;
            text-align: left;
          }
          .orther-search-main {
            .orther-search-row {
              display: flex;
            }
          }
        }
      }
      .main {
        background: #fff;
        padding: 37px;
        .main-title {
          display: flex;
          justify-content: space-between;
          height: 14px;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          border-left: 3px solid #2e68ea;
          padding-left: 5px;
          margin-bottom: 10px;
        }
        .main-row {
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }
      }
    }
    .w190 {
      width: 190px;
    }
    .common-left {
      margin-right: 0px;
    }
    .foot {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 30px;
      margin-bottom: 0px;
    }
  }
}
</style>
<style lang="scss">
.claim-register {
  .main {
    .el-form-item {
      display: flex;
      flex-direction: column;
      .el-form-item__label {
        width: 120px !important;
        text-align: left;
      }
      .el-form-item__content {
        margin-left: 0px !important;
      }
    }
  }
  .main-row {
    display: flex;
    .el-form-item {
      width: 25%;
      box-sizing: border-box;
      margin-right: 40px;
      .el-select {
        width: 100% !important;
      }
    }
    .w50 {
      width: 50%;
      margin-right: 0px;
      display: flex;
    }
    .remarks {
      width: 53%;
    }
    // .common-right {
    //   margin-right: 0px;
    // }
    .quantity {
      margin-right: 40px;
    }
    .images {
      width: 100%;
      height: auto;
      margin-bottom: 0;
      .el-form-item__content {
        height: auto;
        .el-upload-list {
          .el-upload-list__item {
            width: 64px;
            height: 64px;
            margin-top: 0px;
          }
        }
        .el-upload--picture-card {
          width: 64px;
          height: 64px;
          border: 0px;
          line-height: 0px;
          .el-upload-list__item-thumbnail {
            height: 64px;
          }
        }
        .authorize {
          .el-upload-list__item-delete {
            display: none;
          }
        }
        .none {
          .el-upload--picture-card {
            display: none;
          }
        }
        .el-button {
          width: 64px;
          height: 64px;
          background: #fff;
          border-radius: 2px;
          border: 1px solid#eee;
          > span {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .add {
              color: #eee;
              font-size: 30px;
            }
          }
        }
        .el-upload__tip {
          margin: 0;
          color: rgba(192, 196, 204, 1);
          line-height: 20px;
          display: inline-block;
          padding-top: 48px;
          margin-left: 10px;
        }
        ul {
          width: 320px;
        }
      }
    }
  }
}
</style>
